import { NgModule } from '@angular/core';
import { StorefrontComponentModule } from './components';

@NgModule({
  imports: [StorefrontComponentModule],
  exports: [StorefrontComponentModule],
})
export class SdvorMainUiModule {}
